import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { TECHNICAL_SHEET_MATERIAL } from '../types/technical-sheet-material.js';
/**
 * Descriptor for Insumos da Ficha Técnica (Technical Sheet Material).
 * Subcollection: org/{orgId}/technical-sheet/{technicalSheetId}/material
 *
 * Resolve repository with context: { orgId, technicalSheetId }.
 */
export const technicalSheetMaterialDescriptor = {
    name: TECHNICAL_SHEET_MATERIAL,
    label: 'Insumos da Ficha Técnica',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/technical-sheet/{technicalSheetId}/material',
    pathPatternKeys: {
        orgId: 'string',
        technicalSheetId: 'string',
    },
    version: 1,
    description: 'Componente, produto, quantidade e tipo de consumo (Linear, Lote, Fixo)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: filho de entidade versionada (spec 0045) — itens em cache voltariam velhos após Recarregar e seriam regravados por cima.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique material identifier',
        },
        {
            name: 'componentId',
            label: 'Componente vinculado',
            type: 'string',
            required: true,
            description: 'Reference to the component',
        },
        {
            name: 'productId',
            label: 'Produto vinculado',
            type: 'string',
            required: true,
            description: 'Reference to the product (material anchor)',
        },
        {
            name: 'variantId',
            label: 'Variante',
            type: 'string',
            required: false,
            description: 'FK ProductVariant — set when the input is a specific product variation (color / option). Absent = pure product.',
        },
        {
            name: 'quantity',
            label: 'Quantidade',
            type: 'number',
            display: 'quantity',
            required: true,
            description: 'Quantity',
        },
        {
            name: 'consumptionType',
            label: 'Tipo de consumo',
            type: 'string',
            required: true,
            description: 'Linear, Lote ou Fixo',
        },
        {
            name: 'processId',
            label: 'Processo',
            type: 'string',
            required: false,
            description: 'Processo vinculado ao material (sugerido a partir do componente)',
        },
        {
            name: 'quantityPerBatchOrFixed',
            label: 'Tamanho do lote / valor fixo',
            type: 'number',
            display: 'quantity',
            required: false,
            description: 'Lote: batch size (production units per batch); Fixo: fixed total. Required when type is Lote or Fixo',
        },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        {
            fieldName: 'componentId',
            targetEntity: 'Component',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Componente vinculado ao insumo',
        },
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Produto vinculado ao insumo',
        },
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Variante do produto vinculada ao insumo (opcional)',
        },
        {
            fieldName: 'processId',
            targetEntity: 'Process',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Processo vinculado ao material',
        },
        ...AUDIT_FOREIGN_KEYS,
    ],
};
//# sourceMappingURL=technical-sheet-material.descriptor.js.map